__turbopack_context__.v({
  "container": "ContentImage-module-scss-module__Chpygq__container",
  "content": "ContentImage-module-scss-module__Chpygq__content",
  "contentSwipable": "ContentImage-module-scss-module__Chpygq__contentSwipable",
  "swipableContantContainer": "ContentImage-module-scss-module__Chpygq__swipableContantContainer",
});
